import { useRef } from 'react';
import { useSafeLayoutEffect } from './use-safe-layout-effect.js';

/**
 * Gets `value` from the last render.
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();

  useSafeLayoutEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
